import React from 'react';
import LazyLoad from 'react-lazyload';
import { fontFamilies } from '../UI/Font';

export const TextContainer: React.FC = ({ children }) => (
  <div>
    {children}
    <style jsx>{`
      div {
        height: 100px;
        margin-bottom: 11px;
      }
    `}</style>
  </div>
);

const TitleIcon: React.FC<{ src: string }> = ({ src }) => (
  <LazyLoad>
    <img src={src} style={{ marginTop: '-8px' }} />
  </LazyLoad>
);
const TitleText: React.FC = ({ children }) => (
  <>
    <span>{children}</span>
    <style jsx>{`
      span {
        text-align: center;
        font-family: ${fontFamilies.regular};
        font-size: 15px;
        font-weight: 900;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: 34px;
        margin-bottom: 20px;
        margin-left: 5px;
      }
    `}</style>
  </>
);

const Title: React.FC<{ iconSrc: string; title: string }> = ({ iconSrc, title }) => (
  <>
    <TitleIcon src={iconSrc} />
    <TitleText>{title}</TitleText>
  </>
);

export const AuthenticTitle: React.FC = () => (
  <Title
    iconSrc="https://cdn-images.italist.com/image/upload/v1583949723/icons/home/authentic.svg"
    title={'100% Authentic'}
  />
);
export const ShippingTitle: React.FC = () => (
  <Title
    iconSrc="https://cdn-images.italist.com/image/upload/v1583949723/icons/home/Shipping.svg"
    title={'Free express shipping'}
  />
);
export const SecureShoppingTitle: React.FC = () => (
  <Title
    iconSrc="https://cdn-images.italist.com/image/upload/v1583949723/icons/home/secure.svg"
    title={'Secure shopping'}
  />
);
export const CustomerSupportTitle: React.FC = () => (
  <Title
    iconSrc="https://cdn-images.italist.com/image/upload/v1583949723/icons/home/chat.svg"
    title={'24/7 customer support'}
  />
);
